import { Scene } from "../../tools/Scene";

export class GizmoAnimationScene extends Scene {
    gizmo:Phaser.GameObjects.Sprite|null = null;

    constructor(scene){
        super(scene);
    }

    prescaleCreate() {
        let position = this.scaleManager.getRelativePosition(.5,.5);
        let gizmo = this.add.sprite(position.x, position.y, '').play('gizmo_run');
        this.gizmo = gizmo;
    }
    reorient(landscape: boolean) {
        let position;
        position = this.scaleManager.getRelativePosition(.5,.5);
        this.gizmo!.setPosition(position.x,position.y-50);
    }
}